// Функци From DTO берет сырые данные с бека и превращает их в данные котоые хочет видеть фронт

function companyAccountResourceFromDtoService(dto, meta) {
  const { status } = meta.response;

  return { data: dto, status };
}

export default companyAccountResourceFromDtoService;
